import React from "react";
import CardElectric from "./CardElectric.js";
import HeaderElectric from "./HeaderElectric.js";

const Electric = () => {
  return (
    <div>
      <HeaderElectric></HeaderElectric>
      <CardElectric></CardElectric>
    </div>
  );
};

export default Electric;
